<template>
  <vl-calendar
    @input="(date) => emitDate(date)"
    :is-selected="isSelected"
    :is-disabled="calculateDisabled"
    :is-occupied="calculateOccupied"
    :is-partially="calculatePartially"
    :selected-date="{ start: startDate, end: endDate }"
    :custom-classes="customClasses"
    :show-weeks-number="showWeeksNumber"
    :default-date="defaultDate"
    :single-month="singleMonth"
    :first-day-of-week="firstDayOfWeek"
    :minDate="changeDate === 'start' ? minStartDate : minEndDate"
    :maxDate="changeDate === 'start' ? maxStartDate : maxEndDate"
    :change-date="changeDate"
    max-month-start="0"
    :max-month-end="maxMonths"
    ref="calendar"
  />
</template>

<script>
import VlCalendar from "./vl-calendar";
import { DAYS_SHORTCUTS } from "@/constants/days";
import { provide, ref, watchEffect } from "vue";
// import { createLogger } from "vuex";

export default {
  name: "VlRangeSelector",
  components: {
    VlCalendar,
  },
  setup(props) {
    const selectDate = ref(props.changeDate);
    const disabledWeekdays = ref(props.disabledWeekdays);
    const start = new Date(props.startDate);
    const end = new Date(props.maxEndDate);


    const maxMonths =
      (end.getFullYear() - start.getFullYear()) * 12 +
      (end.getMonth() - start.getMonth());

    watchEffect(() => {
      selectDate.value = props.changeDate;
      disabledWeekdays.value = props.disabledWeekdays;
    });

    provide("selectDate", selectDate);
    provide("disabledWeekdays", disabledWeekdays);
    return { maxMonths };
  },
  props: {
    startDate: String,
    endDate: String,
    minStartDate: String,
    minEndDate: String,
    maxStartDate: String,
    maxEndDate: String,
    disabledWeekdays: Array,
    changeDate: String,
    customClasses: Object,
    showWeeksNumber: Boolean,
    defaultDate: String,
    blockStartDate: Boolean,
    disabled: Boolean,
    disabledDates: [Object, Array],
    disabledStartDates: [Object, Array],
    disabledEndDates: [Object, Array],
    isDisabled: Function,
    isOccupied: Function,
    isPartially: Function,
    singleMonth: Boolean,
    enableSingleDate: Boolean,
    firstDayOfWeek: {
      type: String,
      validator: (v) => DAYS_SHORTCUTS.includes(v),
      default: "mo",
    },
    occupied: Array,
    partially: Array,
    lang: { required: false, default: "DE" },
  },
  methods: {
    emitDate(date) {
      if (
        this.blockStartDate ||
        (this.startDate && !this.endDate && date >= this.startDate)
      ) {
        this.$emit("update:endDate", date);
        this.$emit("update:changeDate", null);
      } else {
        if (this.changeDate == "end") {
          if (date < this.startDate) {
            this.$emit("update:startDate", date);
            this.$emit("update:endDate", null);
            this.$emit("update:changeDate", "end");
          } else {
            this.$emit("update:endDate", date);
            this.$emit("update:changeDate", null);
          }
        } else {
          this.$emit("update:startDate", date);
          this.$emit("update:changeDate", "end");
          let maxDate = 0;

          if (parseInt(this.maxDate) > 0) {
            maxDate = new Date(date);
            maxDate.setDate(maxDate.getDate() + parseInt(this.maxDate));
            maxDate = this.formateDate(maxDate);
          }
          if (this.endDate < date || (this.endDate > maxDate && maxDate != 0)) {
            this.$emit("update:endDate", null);
          }
        }
      }
      this.$emit("focus");
    },

    isSelected(date) {
      if (!this.startDate && !this.endDate) {
        return false;
      } else if (!this.endDate) {
        return this.startDate === date;
      } else {
        return date >= this.startDate && date <= this.endDate;
      }
    },
    formateDate(date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = date.getFullYear();
      return yyyy + "-" + mm + "-" + dd;
    },
    calculateOccupied(date) {
      if (Array.isArray(this.occupied)) {
        return this.occupied.includes(date);
      }
    },
    calculatePartially(date) {
      if (Array.isArray(this.partially)) {
        return this.partially.includes(date);
      }
    },
    calculateDisabled(date) {
      const minDate = this.changeDate === "start" ? this.minStartDate : this.minEndDate;
      const maxDate =
        this.changeDate === "start" ? this.maxStartDate : this.maxEndDate;

      if (date < minDate && minDate != null) {
        return date;
      }

      if (date > maxDate && minDate != null) {
        return date;
      }

      if (maxDate < date) {
        return date;
      }
      // console.log(this.changeDate);
      const disabledDays =
        this.changeDate === "start"
          ? this.disabledStartDates || this.disabledDates || []
          : this.disabledEndDates || [];
      // console.log("disabledDays", disabledDays);
      // console.log("this.disabledEndDates", this.disabledEndDates);
      // console.log("disabledWeekdays", this.disabledWeekdays);
      if (Array.isArray(disabledDays)) {
        if (date <= 6) {
          return this.disabledWeekdays.includes(date);
        } else {
          return disabledDays.includes(date);
        }
      } else {
        const from = disabledDays.from;
        const to = disabledDays.to;

        const isAfterFrom = from && from <= date;
        const isBeforeTo = to && date <= to;

        if (from && to) {
          return isAfterFrom && isBeforeTo;
        }

        if (from) {
          return isAfterFrom;
        }

        if (to) {
          return isBeforeTo;
        }
      }
    },
  },
};
</script>
